import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the BaikeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BaikeProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello BaikeProvider Provider');
  }

  getBaikeList() {
    return this.http.hPost('/get_baike_list');
  }

  switchBaike(is_switch) {
    return this.http.hPost('/switch_baike', { switch: is_switch });
  }

  switchABaike(is_switch, material_id) {
    let params = {
      switch: is_switch,
      material_id: material_id,
    };
    return this.http.hPost('/switch_a_baike', params);
  }
}



// WEBPACK FOOTER //
// ./src/providers/baike/baike.ts